import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useRef, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Loading from "../../cross/Loading";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { ICalculoDesviacion, ICausasAsignadasYCompletadas, IDesviacion } from "../../entities/IDesviacion";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { ROW_COUNT } from "../../helpers/variableHelper";
import DesviacionService from "../../services/DesviacionService";
import { E_TipoBusquedaDesviacion } from "../../enums/E_TipoBusquedaDesviacion";
import { shortDate } from "../../helpers/dateHelper";
import { ETipoCausa } from "../../enums/E_TipoCausa";
import { ICausaInmediata } from "../../entities/ICausaInmediata";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";

interface IHomeDesviacion {
  loading?: boolean;
  items?: Array<IDesviacion>;
  causas?: ICausasAsignadasYCompletadas;
  seleccionada?: number;
  is_test?: boolean;
}

export default function HomeDesviacion({ is_test, loading = true, items, causas, seleccionada }: IHomeDesviacion) {// NOSONAR Dejamos justificado que estas validaciones corresponden a validacion de propiedades en la carga del home de desviaciones
  const userInfoToken = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [calculoDesviaciones, setCalculoDesviaciones] = useState<ICalculoDesviacion | null>(null);
  const [boxSeleccionada, setBoxSeleccionada] = useState<E_TipoBusquedaDesviacion>(seleccionada || E_TipoBusquedaDesviacion.Ninguna);
  const [listDesviaciones, setListDesviaciones] = useState<Array<IDesviacion>>(items || []);
  const totalPageListDesviaciones = useRef<number>(0);
  const totalPageListCausasI = useRef<number>(0);
  const totalPageListCausasB = useRef<number>(0);
  const totalPageListCausasS = useRef<number>(0);
  const [listCausasDesviaciones, setListCausasDesviaciones] = useState<ICausasAsignadasYCompletadas | null>(causas || null); //
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentAccionesID = (value: any) => {
    return (
      <div>
        <i
          className="bi bi-search iconSearch"
          title="Ver Desviación"
          onClick={() => {
            window.location.href = `/agregardesviacion?id=${value.row.original.ID}`;
          }}></i>
      </div>
    );
  };

  const componentAccionesIdDesviacion = (info: any, tc: ETipoCausa) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          window.location.href = `/agregardesviacion?id=${info.row.original.ID_DESVIACION}&idCausa=${info.row.original.ID}&tp=${tc}`;
        }}></i>
    );
  };

  const renderBoxTitle = () => {
    if (boxSeleccionada === E_TipoBusquedaDesviacion.Generadas) {
      return "Generadas";
    } else if (boxSeleccionada === E_TipoBusquedaDesviacion.Asignadas) {
      return "Asignadas";
    } else {
      return "Completadas";
    }
  };

  usePromiseEffect(async () => {
    let token = await userInfoToken;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    try {
      let resultCalculoHome = await DesviacionService.getEstadisticasHome(token, currUser);
      setCalculoDesviaciones(resultCalculoHome);
    } catch (error) {}
    setIsLoading(false);
  }, []);

  const columnHelperDesvGeneradas = createColumnHelper<IDesviacion>();
  let columnsDefDesviaciones = [
    columnHelperDesvGeneradas.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ASUNTO, {
      id: "ASUNTO",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Asunto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_DETECCION, {
      id: "FECHA_DETECCION",
      cell: (info: CellContext<IDesviacion, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Detección"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<IDesviacion, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Creación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ESTADO, {
      id: "ESTADO",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.POTENCIALIDAD, {
      id: "POTENCIALIDAD",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Potencialidad"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.TIPO_DESVIACION, {
      id: "TIPO_DESVIACION",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Tipo de Desviación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperDesvGeneradas.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IDesviacion, string>) => componentAccionesID(info),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;
  const getColumnsAcciones = (tc: ETipoCausa) => {
    return [
      columnHelperDesvGeneradas.accessor((row) => row.CORRELATIVO, {
        id: "CORRELATIVO",
        cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
        header: () => component("Correlativo"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperDesvGeneradas.accessor((row) => row.RESPONSABLE_DISPLAY, {
        id: "RESPONSABLE",
        cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
        header: () => component("Responsable"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperDesvGeneradas.accessor((row) => row.FECHA_ASIGNACION, {
        id: "FECHA_ASIGNACION",
        cell: (info: CellContext<IDesviacion, Date>) => componentValue(shortDate(info.getValue())),
        header: () => component("Fecha de Asignación"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperDesvGeneradas.accessor((row) => row.FECHA_HASTA, {
        id: "FECHA_HASTA",
        cell: (info: CellContext<IDesviacion, Date>) => componentValue(shortDate(info.getValue())),
        header: () => component("Fecha Término"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperDesvGeneradas.accessor((row) => row.ACCION, {
        id: "ACCION",
        cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
        header: () => component("Acción"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperDesvGeneradas.accessor((row) => row.ESTADO, {
        id: "ESTADO",
        cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
        header: () => component("Estado"),
        tipo: ITipo_Campo.text,
      } as any),
      columnHelperDesvGeneradas.accessor((row) => row.ID, {
        id: "ACCIONES",
        cell: (info: CellContext<ICausaInmediata, string>) => componentAccionesIdDesviacion(info, tc),
        header: () => component("Acciones"),
        tipo: ITipo_Campo.text,
        disableSorting: true,
      } as any),
    ] as any;
  };

  const handleReloadDesviacionesHome = async (tipoBusqueda: E_TipoBusquedaDesviacion, pagination?: IPagination) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = is_test
      ? { data: [], pages: 10 }
      : await DesviacionService.getListadoDesviacionesHome(token, {
          ...defaultPagination,
          TIPO_BUSQUEDA: tipoBusqueda,
          USUARIO: currentUser?.email as string,
        });
    let arrDesviacionesGeneradas = result.data;
    totalPageListDesviaciones.current = result.pages;
    setListDesviaciones(arrDesviacionesGeneradas);
    setBoxSeleccionada(tipoBusqueda);
  };
  const handleReloadCausas = async (tipo: E_TipoBusquedaDesviacion, pagination?: IPagination) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = is_test
      ? {
          cipages: 10,
          cbpages: 10,
          cspages: 10,
          data: { causasBasicas: [], causasInmediatas: [], causasSistema: [] } as ICausasAsignadasYCompletadas,
        }
      : await DesviacionService.getListadoCausasHome(token, {
          ...defaultPagination,
          TIPO_BUSQUEDA: tipo,
          USUARIO: currentUser?.email as string,
        });

    totalPageListCausasI.current = result.cipages;
    totalPageListCausasB.current = result.cbpages;
    totalPageListCausasS.current = result.cspages;
    setListCausasDesviaciones(result.data);
    setBoxSeleccionada(tipo);
  };

  return isLoading ? (
    <>
      <Loading />
    </>
  ) : (
    <div className="row">
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container mb-4">
            <div className="card bgGris p-3 border-0">
              <h3 className="titSecundario colorTit">Desviaciones</h3>
              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-3">
                  <div
                    data-testid="btngeneradas"
                    className={`card p-3 modulo shadow ${boxSeleccionada === E_TipoBusquedaDesviacion.Generadas && "moduloActive"}`}
                    onClick={async () => {
                      handleReloadDesviacionesHome(E_TipoBusquedaDesviacion.Generadas);
                    }}>
                    <div className="row">
                      <div className="col-8 d-flex align-items-center">
                        <i className="bi bi-file-text colorVerde"></i>
                        <span>Generadas</span>
                      </div>
                      <div className="col-4">
                        <span className="caja text-white gradienteVerde">
                          <span>{calculoDesviaciones?.DESVIACIONES_GENERADAS}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-3">
                  <div
                    data-testid="btnasignadas"
                    className={`card p-3 modulo shadow ${boxSeleccionada === E_TipoBusquedaDesviacion.Asignadas && "moduloActive"}`}
                    onClick={async () => {
                      handleReloadDesviacionesHome(E_TipoBusquedaDesviacion.Asignadas);
                    }}>
                    <div className="row">
                      <div className="col-8 d-flex align-items-center">
                        <i className="bi bi-file-text colorVerde"></i>
                        <span>Asignadas</span>
                      </div>
                      <div className="col-4">
                        <span className="caja text-white gradienteVerde">
                          <span>{calculoDesviaciones?.DESVIACIONES_ASIGNADAS}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-3">
                  <div
                    data-testid="btncompletadas"
                    className={`card p-3 modulo shadow ${boxSeleccionada === E_TipoBusquedaDesviacion.Completadas && "moduloActive"}`}
                    onClick={async () => {
                      handleReloadDesviacionesHome(E_TipoBusquedaDesviacion.Completadas);
                    }}>
                    <div className="row">
                      <div className="col-8 d-flex align-items-center">
                        <i className="bi bi-file-text colorVerde"></i>
                        <span>Completadas</span>
                      </div>
                      <div className="col-4">
                        <span className="caja text-white gradienteVerde">
                          <span>{calculoDesviaciones?.DESVIACIONES_COMPLETADAS}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {!currentUser?.external && (
                  <div className="col-sm-12 col-md-6 col-lg-3">
                    <div
                      className="card p-3 modulo shadow"
                      onClick={() => {
                        window.location.href = "/agregardesviacion";
                      }}>
                      <div className="row ">
                        <div className="col-12 text-center colorAzul ">
                          Agregar <i className="bi bi-plus-circle-fill"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-12 mt-3 mb-1">
                  <h3 className="titSecundario colorTit">Acciones Asignadas</h3>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-3">
                  <div
                    className={`card p-3 modulo shadow ${boxSeleccionada === E_TipoBusquedaDesviacion.Aasignadas && "moduloActive"}`}
                    onClick={async () => {
                      handleReloadCausas(E_TipoBusquedaDesviacion.Aasignadas);
                    }}>
                    <div className="row">
                      <div className="col-8 d-flex align-items-center">
                        <i className="bi bi-file-text colorAzul"></i>
                        <span>Acciones Asignadas</span>{" "}
                      </div>
                      <div className="col-4">
                        <span className="caja text-white gradienteAzul">
                          <span>{calculoDesviaciones?.ACCIONES_ASIGNADAS}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-3">
                  <div
                    className={`card p-3 modulo shadow ${boxSeleccionada === E_TipoBusquedaDesviacion.Acompletadas && "moduloActive"}`}
                    onClick={async () => {
                      handleReloadCausas(E_TipoBusquedaDesviacion.Acompletadas);
                    }}>
                    <div className="row">
                      <div className="col-8 d-flex align-items-center">
                        <i className="bi bi-file-text colorAzul"></i>
                        <span>Completadas Asignadas</span>{" "}
                      </div>
                      <div className="col-4">
                        <span className="caja text-white gradienteAzul">
                          <span>{calculoDesviaciones?.ACCIONES_COMPLETADAS}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {(boxSeleccionada === E_TipoBusquedaDesviacion.Generadas ||
            boxSeleccionada === E_TipoBusquedaDesviacion.Asignadas ||
            boxSeleccionada === E_TipoBusquedaDesviacion.Completadas) && (
            <div className="row" id="tlbGeneradas">
              <div className="col-12">
                <div className="container-fluid mb-4">
                  <h1 className="titPrincipal colorTit mt-2">{renderBoxTitle()}</h1>

                  <div className="row">
                    <div className="col-12">
                      <AdminListaPagination
                        defaultSortBy="ID"
                        sortDirection="DESC"
                        totalPages={totalPageListDesviaciones}
                        resultPerPage={ROW_COUNT}
                        callback={(pagination) => {
                          console.log(pagination);
                          handleReloadDesviacionesHome(boxSeleccionada, pagination);
                        }}
                        data={listDesviaciones}
                        reload={() => {
                          handleReloadDesviacionesHome(boxSeleccionada);
                        }}
                        columnsDef={columnsDefDesviaciones}
                        hideAdd={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {(boxSeleccionada === E_TipoBusquedaDesviacion.Aasignadas || boxSeleccionada === E_TipoBusquedaDesviacion.Acompletadas) && (
            <div id="seccionAccionesAsignadas">
              <h1 className="titPrincipal colorTit mt-2">
                {boxSeleccionada === E_TipoBusquedaDesviacion.Aasignadas ? "Acciones Asignadas" : "Completadas Asignadas"}
              </h1>
              <Tabs defaultActiveKey="básicas" id="uncontrolled-tab-example" className="mb-3">
                <Tab
                  eventKey="inmediatas"
                  title={
                    <span>
                      Causas Inmediatas (Corrección) <i className="bi bi-eye" />{" "}
                    </span>
                  }>
                  <AdminListaPagination
                    defaultSortBy="ID"
                    sortDirection="DESC"
                    totalPages={totalPageListCausasI}
                    resultPerPage={ROW_COUNT}
                    callback={(pagination) => {
                      handleReloadCausas(boxSeleccionada, pagination);
                    }}
                    data={listCausasDesviaciones?.causasInmediatas || []}
                    reload={() => {
                      handleReloadCausas(boxSeleccionada);
                    }}
                    columnsDef={getColumnsAcciones(ETipoCausa.Inmediata)}
                    hideAdd={true}
                  />
                </Tab>
                <Tab
                  eventKey="básicas"
                  title={
                    <span>
                      Causas Básicas <i className="bi bi-eye" />
                    </span>
                  }>
                  <AdminListaPagination
                    defaultSortBy="ID"
                    sortDirection="DESC"
                    totalPages={totalPageListCausasB}
                    resultPerPage={ROW_COUNT}
                    callback={(pagination) => {
                      handleReloadCausas(boxSeleccionada, pagination);
                    }}
                    data={listCausasDesviaciones?.causasBasicas || []}
                    reload={() => {
                      handleReloadCausas(boxSeleccionada);
                    }}
                    columnsDef={getColumnsAcciones(ETipoCausa.Basica)}
                    hideAdd={true}
                  />
                </Tab>
                <Tab
                  eventKey="sistema"
                  title={
                    <span>
                      Ámbitos de Gestión <i className="bi bi-eye" />{" "}
                    </span>
                  }>
                  <AdminListaPagination
                    defaultSortBy="ID"
                    sortDirection="DESC"
                    totalPages={totalPageListCausasS}
                    resultPerPage={ROW_COUNT}
                    callback={(pagination) => {
                      handleReloadCausas(boxSeleccionada, pagination);
                    }}
                    data={listCausasDesviaciones?.causasSistema || []}
                    reload={() => {
                      handleReloadCausas(boxSeleccionada);
                    }}
                    columnsDef={getColumnsAcciones(ETipoCausa.Sistema)}
                    hideAdd={true}
                  />
                </Tab>
              </Tabs>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
